import React from 'react';
import { getFormattedDate } from '../../utils/utilities';
import clsx from 'clsx';
import { IActivityItem } from './OrderDetails';

interface Props extends IActivityItem {
	currency: string;
}

export const PaymentActivityTableRow = (props: Props): React.ReactElement => {
	const { currency, ...item } = props;
	const { paymentDate, type, description, totalAmount } = item;
	return (
		<tr>
			<td>
				<div className="d-flex flex-column justify-content-start align-items-start w-100px">
					<span className="fs-6">
						{getFormattedDate(paymentDate, 'dd MMM, yyyy')}
					</span>
					<span className="fs-8">
						{getFormattedDate(paymentDate, 'hh:mm a')}
					</span>
				</div>
			</td>
			<td className="fs-6">
				{type}
			</td>
			<td className="fs-6">
				{description}
			</td>
			<td>
				<div className={clsx('fs-6 fw-bolder w-90px', (type === 'refund' || type === 'chargeback') && 'text-danger')}>
					{currency}{(totalAmount / 100).toFixed(2)}
				</div>
			</td>
		</tr>
	);
};
